import Vue from 'vue';
import Component from 'vue-class-component';
import { IObjectAnyKeyVal } from '@/models/common';

@Component
export class StaticAttrsMixin extends Vue {

	public staticClass: IObjectAnyKeyVal = (() => {
		const staticClass: string = this.$vnode.data?.staticClass || '';
		const objClass: IObjectAnyKeyVal = this.$vnode.data?.class || {};

		if (staticClass) staticClass.split(' ').forEach(i => objClass[i] = true);

		return objClass;
	})();

}